"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ReducerRegistry {
    constructor() {
        this._reducers = {};
        this._listener = null;
    }
    get reducers() {
        return { ...this._reducers };
    }
    set listener(value) {
        this._listener = value;
    }
    register(name, reducer) {
        this._reducers = { ...this._reducers, [name]: reducer };
        if (this._listener) {
            this._listener(this.reducers);
        }
    }
}
exports.default = new ReducerRegistry();



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/ReducerRegistry.ts